import React, { useEffect, useState } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";

interface ProtectedRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component, ...rest }) => {
  console.log("ProtectedRoute is called");
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  useEffect(() => {
    console.log("ProtectedRoute is called token");
    const checkToken = async () => {
      try {
        const token = await OfficeRuntime.storage.getItem("token");
        console.log("token is", token);
        setIsAuthorized(!!token);
      } catch (err) {
        console.error("Error reading token:", err);
        setIsAuthorized(false);
      }
    };

    checkToken();
  }, []);

  if (isAuthorized === null) return null; // or show loader

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthorized ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default ProtectedRoute;
